"use client";

import { c as _c } from "react/compiler-runtime";
import { defaultNewsHashags } from "@/constants/project-specific/news/defaults";
import { generateFBLink, generateLineLink, generatePinterestPinItLink, generateRedditLink, generateTelegramLink, generateTwitterLink, generateWhatsAppLink } from "@/util/url/socialShareUrl";
import { SocialIcon } from "react-social-icons";
interface Props {
  url: string;
  message?: string;
  shareMessage?: string;
  hashtags?: string[];
  size?: number;
  imageUrl?: string;
}
export function SocialShareButtons(t0) {
  const $ = _c(67);
  const {
    url,
    message,
    shareMessage,
    hashtags,
    size: t1,
    imageUrl
  } = t0;
  const size = t1 === undefined ? 25 : t1;
  const t2 = shareMessage ?? "Share to Social Media";
  let t3;
  if ($[0] !== t2) {
    t3 = <div className="flex items-center"><span className="text-md mb-3">{t2}</span></div>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = message ?? "Check out this page!";
  let t5;
  if ($[2] !== t4 || $[3] !== url) {
    t5 = generateTwitterLink(url, {
      title: t4
    });
    $[2] = t4;
    $[3] = url;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== size) {
    t6 = {
      height: size,
      width: size
    };
    $[5] = size;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <SocialIcon url={t5} style={t6} />;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  const t8 = message ?? "Check out this page!";
  let t9;
  if ($[10] !== t8 || $[11] !== url) {
    t9 = generateTelegramLink(url, {
      title: t8
    });
    $[10] = t8;
    $[11] = url;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== size) {
    t10 = {
      height: size,
      width: size
    };
    $[13] = size;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <SocialIcon url={t9} style={t10} />;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== imageUrl || $[19] !== message || $[20] !== size || $[21] !== url) {
    t12 = imageUrl ? <SocialIcon url={generatePinterestPinItLink(url, {
      media: imageUrl,
      description: message ?? "Check out this page!"
    })} style={{
      height: size,
      width: size
    }} /> : null;
    $[18] = imageUrl;
    $[19] = message;
    $[20] = size;
    $[21] = url;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  const t13 = message ?? "Check out this page!";
  let t14;
  if ($[23] !== t13 || $[24] !== url) {
    t14 = generateRedditLink(url, {
      title: t13
    });
    $[23] = t13;
    $[24] = url;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  if ($[26] !== size) {
    t15 = {
      height: size,
      width: size
    };
    $[26] = size;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t14 || $[29] !== t15) {
    t16 = <SocialIcon url={t14} style={t15} />;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const t17 = message ?? "Check out this page!";
  const t18 = hashtags ?? defaultNewsHashags;
  let t19;
  if ($[31] !== t17 || $[32] !== t18 || $[33] !== url) {
    t19 = generateFBLink(url, {
      quote: t17,
      hashTags: t18
    });
    $[31] = t17;
    $[32] = t18;
    $[33] = url;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== size) {
    t20 = {
      height: size,
      width: size
    };
    $[35] = size;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t19 || $[38] !== t20) {
    t21 = <SocialIcon url={t19} style={t20} />;
    $[37] = t19;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  const t22 = message ?? "Check out this page!";
  let t23;
  if ($[40] !== t22 || $[41] !== url) {
    t23 = generateWhatsAppLink(url, {
      title: t22
    });
    $[40] = t22;
    $[41] = url;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] !== size) {
    t24 = {
      height: size,
      width: size
    };
    $[43] = size;
    $[44] = t24;
  } else {
    t24 = $[44];
  }
  let t25;
  if ($[45] !== t23 || $[46] !== t24) {
    t25 = <SocialIcon url={t23} style={t24} />;
    $[45] = t23;
    $[46] = t24;
    $[47] = t25;
  } else {
    t25 = $[47];
  }
  const t26 = message ?? "Check out this page!";
  let t27;
  if ($[48] !== t26 || $[49] !== url) {
    t27 = generateLineLink(url, {
      title: t26
    });
    $[48] = t26;
    $[49] = url;
    $[50] = t27;
  } else {
    t27 = $[50];
  }
  let t28;
  if ($[51] !== size) {
    t28 = {
      height: size,
      width: size
    };
    $[51] = size;
    $[52] = t28;
  } else {
    t28 = $[52];
  }
  let t29;
  if ($[53] !== t27 || $[54] !== t28) {
    t29 = <SocialIcon url={t27} style={t28} />;
    $[53] = t27;
    $[54] = t28;
    $[55] = t29;
  } else {
    t29 = $[55];
  }
  let t30;
  if ($[56] !== t11 || $[57] !== t12 || $[58] !== t16 || $[59] !== t21 || $[60] !== t25 || $[61] !== t29 || $[62] !== t7) {
    t30 = <div className="flex items-center space-x-2">{t7}{t11}{t12}{t16}{t21}{t25}{t29}</div>;
    $[56] = t11;
    $[57] = t12;
    $[58] = t16;
    $[59] = t21;
    $[60] = t25;
    $[61] = t29;
    $[62] = t7;
    $[63] = t30;
  } else {
    t30 = $[63];
  }
  let t31;
  if ($[64] !== t3 || $[65] !== t30) {
    t31 = <><div className="flex items-center flex-col">{t3}{t30}</div></>;
    $[64] = t3;
    $[65] = t30;
    $[66] = t31;
  } else {
    t31 = $[66];
  }
  return t31;
}